import { useCallback, useState } from 'react';

/**
 * Maneja el estado abierto/cerrado de varias secciones colapsables por label.
 * Todas arrancan abiertas (undefined => abierta).
 */
export function useCollapsible() {
  const [openMap, setOpenMap] = useState({});

  const isOpen = useCallback((label) => openMap[label] !== false, [openMap]);

  const toggle = useCallback((label) => {
    setOpenMap((prev) => ({ ...prev, [label]: prev[label] === false }));
  }, []);

  return { isOpen, toggle };
}
